import { useEffect, useRef, useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { HOME_PAGE, HOME_PAGE_CONSTANTS } from "../constants/app-constants";
import { LANGUAGE } from "../constants/language";
import { modifyMediaUrl } from "../helpers/modifyMediaUrl";
import { i18n, initializeI18n } from "../localization/i18n";
import { getSpecialPackagesData } from "../services/homePageService";
import { Carousel } from "primereact/carousel";
import { useScrollRestore } from '../hook/useScrollRestore';

export default function SpecialPackageSection({ props }) {
  const [packageList, setPackageList] = useState([]);
  const [currentLanguage, setCurrentLanguage] = useState(null);
  const sliderRef = useRef(null);

  const { saveScrollPosition } = useScrollRestore(HOME_PAGE.PACKAGE_SECTION_SCROLL_POSITION);

  useEffect(() => {
    const fetchSpecialPackagesData = async () => {
      const data = await getSpecialPackagesData({ quantity: HOME_PAGE_CONSTANTS.GET_SPECIAL_PACKAGE_QUANTITY });
      setPackageList(data);
    };
    fetchSpecialPackagesData();
  }, []);

  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => {
        setCurrentLanguage(i18n.language);
      });
    } else {
      setCurrentLanguage(i18n.language);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (sliderRef?.current) {
        if (sliderRef.current.state.breakpoint) {
          sliderRef.current.slickGoTo(0);
        }
      }
    }, 100);
  }, [sliderRef.current]);

  function SampleNextArrow({ className, onClick }) {
    return (
      <div className={className} onClick={onClick}>
        <i className="pi pi-angle-right"></i>
      </div>
    );
  }
  function SamplePrevArrow({ className, onClick }) {
    return (
      <div className={className} onClick={onClick}>
        <i className="pi pi-angle-left"></i>
      </div>
    );
  }

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 1150,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 1 }
      },
    ]
  };

  const carouselItemTemplate = (item) => {
    return (
      <div key={item.publicId}>
        <div key={item.publicId} className="special-package-item m-3">
          <div
            className="cursor-pointer"
            onClick={() => {
              saveScrollPosition();
              window.open(`/${currentLanguage}/event-detail/${item.publicId}`, "_self");
            }}
          >
            <div className="item-img relative">
              <img src={modifyMediaUrl(item?.imageUrl || props?.specialPackageSectionDefaultImage)} alt="special-package-image" />
              <div className="label">
                {i18n.language === LANGUAGE.KOREAN
                  ? `${item.orderNumber}${props.specialPackageSectionLabelTop}`
                  : `${props.specialPackageSectionLabelTop} ${item.orderNumber}`}
              </div>
            </div>
            <div className="item-content pb-4 px-3">
              <h6 className="keduall-typography heading-h5-semibold-600 text-default-txt two-line-text">{item?.title}</h6>
              <p className="keduall-typography text-14-normal-400 text-default-txt three-line-text">{item?.subTitle}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="special-package-section" style={{ width: "85%", margin: "0 auto" }}>
      <div className="special-package-title text-center mx-2">
        <h1 className="text-primary-txt-color line-height-57 text-6xl font-semibold margin-bottom-12 mt-0 animate-on-scroll">{props?.specialPackageSectionTitle1}</h1>
        <h4 className="text-2xl font-normal line-height-32 my-0 animate-on-scroll">{props?.specialPackageSectionTitle2}</h4>
      </div>
      <div className="special-package-slider width-limited">
        <Carousel
          value={packageList}
          itemTemplate={carouselItemTemplate}
          numVisible={3}
          numScroll={3}
          className="keduall-carousel"
          responsiveOptions={[
            { breakpoint: "1024px", numVisible: 3, numScroll: 3 },
            { breakpoint: "768px", numVisible: 2, numScroll: 2 },
            { breakpoint: "560px", numVisible: 1, numScroll: 1 },
          ]}
          showIndicators={packageList.length > 3}
          showNavigators={packageList.length > 3}
        />
      </div>
    </div>
  );
}
